// Ajax
export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";

// Course
export const LOAD_COURSES_SUCCESS = "LOAD_COURSES_SUCCESS";
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";

// Projects
export const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";
export const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
export const STORE_PROJECT_SUCCESS = "STORE_PROJECT_SUCCESS";
export const STORE_PROJECT_FAILURE = "STORE_PROJECT_FAILURE";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILURE = "UPDATE_PROJECT_FAILURE";

// Project members
export const ADD_PROJECT_MEMBER_SUCCESS = "ADD_PROJECT_MEMBER_SUCCESS";
export const ADD_PROJECT_MEMBER_FAILURE = "ADD_PROJECT_MEMBER_FAILURE";
export const REMOVE_PROJECT_MEMBER_SUCCESS = "REMOVE_PROJECT_MEMBER_SUCCESS";
export const REMOVE_PROJECT_MEMBER_FAILURE = "REMOVE_PROJECT_MEMBER_FAILURE";

// Project states
export const GET_PROJECT_STATES_SUCCESS = "GET_PROJECT_STATES_SUCCESS";
export const GET_PROJECT_STATES_FAILURE = "GET_PROJECT_STATES_FAILURE";
// Timesheets
export const SET_CURRENT_DATE = "SET_CURRENT_DATE";
export const LOAD_TIMESHEET_SUCCESS = "LOAD_TIMESHEET_SUCCESS";
export const CREATE_TIMESHEET_SUCCESS = "CREATE_TIMESHEET_SUCCESS";
export const UPDATE_TIMESHEET_SUCCESS = "UPDATE_TIMESHEET_SUCCESS";
// Author
export const LOAD_AUTHORS_SUCCESS = "LOAD_AUTHORS_SUCCESS";
// AUTH
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";
export const AUTH_GET_CURRENT_USER_SUCCESS = "AUTH_GET_CURRENT_USER_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// USERS
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_FAILURE = "GET_ALL_USERS_FAILURE";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";

//TASKS
export const GET_MY_TASKS_SUCCESS = "GET_MY_TASKS_SUCCESS";
export const GET_MY_TASKS_FAILURE = "GET_MY_TASKS_FAILURE";
export const STORE_TASK_SUCCESS = "STORE_TASK_SUCCESS";
export const STORE_TASK_FAILURE = "STORE_TASK_FAILURE";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAILURE = "UPDATE_TASK_FAILURE";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";

// TASK TYPES
export const GET_ALL_TASK_TYPES_SUCCESS = "GET_ALL_TASK_TYPES_SUCCESS";
export const GET_ALL_TASK_TYPES_FAILURE = "GET_ALL_TASK_TYPES_FAILURE";

// PROJECTS
export const GET_MY_PROJECTS_SUCCESS = 'GET_MY_PROJECTS_SUCCESS';
export const GET_MY_PROJECTS_FAILURE = 'GET_MY_PROJECTS_FAILURE';

// USERS
export const STORE_USER_SUCCESS = "STORE_USER_SUCCESS";
export const STORE_USER_FAILURE = "STORE_USER_FAILURE";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILURE = "USER_LOGOUT_FAILURE";

// ROLES
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAILURE = "GET_ALL_ROLES_FAILURE";


/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/